/* eslint-disable global-require */
const cloudSourcesConfig = {
  linkedin_ads: require('./linkedin_ads.json'),
  facebook_ads: require('./facebook_ads.json'),
  google_adwords: require('./google_adwords.json'),
  google_search_console: require('./google_search_console.json'),
  intercom: require('./intercom.json'),
  salesforce: require('./salesforce.json'),
  zendesk: require('./zendesk.json'),
  google_sheets: require('./google_sheets.json'),
  google_analytics: require('./google_analytics.json'),
  xero: require('./xero.json'),
  pipedrive: require('./pipedrive.json'),
  marketo: require('./marketo.json'),
  bing_ads: require('./bing_ads.json'),
  zendesk_chat: require('./zendesk_chat.json'),
  netsuite: require('./netsuite.json'),
  mailchimp: require('./mailchimp.json'),
  mixpanel: require('./mixpanel.json'),
  stripe: require('./stripe.json'),
  pardot: require('./pardot.json'),
  freshdesk: require('./freshdesk.json'),
  hubspot: require('./hubspot.json'),
  quickbooks: require('./quickbooks.json'),
  active_campaign: require('./active_campaign.json'),
  sendgrid: require('./sendgrid.json'),
};

export default cloudSourcesConfig;
